/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// import { datadogRum } from "@datadog/browser-rum";

import { IToken, IUser } from 'types/auth';

export interface AuthState {
  token: IToken | null;
  user: IUser | null;
  impersonatedUser?: IUser | null;
  isImpersonating: boolean;
}

const initialState: AuthState = {
  token: null,
  user: null,
  impersonatedUser: null,
  isImpersonating: false,
};

const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLoggedUser: (state, action: PayloadAction<IUser>) => {
      state.user = action.payload;
      // if (process.env.REACT_APP_NAMESPACE === "biz-tecma-prod") {
      //   datadogRum.setUser({
      //     id: action.payload.id,
      //     name: action.payload.firstName,
      //     surname: action.payload.lastName,
      //     email: action.payload.email,
      //     role: action.payload.role,
      //   });
      // }
    },
    setToken: (state, action: PayloadAction<IToken>) => {
      state.token = action.payload;
    },
    unsetLoggedUser: (state) => {
      state.user = null;
      state.token = null;
    },
    setImpersonatedUser: (state, action: PayloadAction<IUser>) => {
      state.isImpersonating = true;
      state.impersonatedUser = action.payload;
    },
  },
});

export const { setLoggedUser, setToken, unsetLoggedUser, setImpersonatedUser } = slice.actions;

export const { reducer } = slice;
